import { uniqueId } from 'lodash'

const WepPostMessage = {
  install (Vue, options) {
    var postMessage = 'postMessage'
    var handlers = {}

    Vue.prototype.$postMessage = function (message, targetOrigin, target = self) {
      if (!targetOrigin) { return }
      if (window[postMessage]) {
        target[postMessage](message, targetOrigin)
      } else {
        console.log('window.postMessage is undefined')
      }
    }

    Vue.prototype.$receiveMessage = function (callback, delay = false) {
      var handlerId = uniqueId('mmp_receiveHandler_')
      var rmCallback
      if (window[postMessage]) {
        if (callback && typeof callback === 'function') {
          handlers[handlerId] = function (e) {
            callback(e, handlerId)
          }
          if (window.addEventListener ) {
            window.addEventListener('message', handlers[handlerId], delay)
          } else {
            window.attachEvent('onmessage', handlers[handlerId] )
          }
        } else {
          console.error('callback is not a function')
        }
      } else {
        console.log('window.postMessage is undefined')
      }
      return rmCallback
    }

    Vue.prototype.$removeMessage = function (handlerId, delay = false) {
      var handlerFunc = handlers[handlerId]
      if (window[postMessage]) {
        if (handlerFunc && typeof handlerFunc === 'function') {
          if (window.addEventListener ) {
            window.removeEventListener('message', handlerFunc, delay)
          } else {
            window.detachEvent('onmessage', handlerFunc )
          }
        }
      }
    }
  }
}
export default WepPostMessage



// WEBPACK FOOTER //
// ./src/plugins/_common/WepPostMessage.js